import React from 'react';

const Error = () => (
  <div className="error-page">
    <h2>Error! Page not found </h2>
  </div>
);

export default Error;
